module.exports = __webpack_public_path__ + "img/muma.311e65f2.png";